import { cn } from "@theprelude/core";
import { AlertIcon, CheckmarkIcon } from "@theprelude/ds";
import { ReactNode } from "react";

export const SummaryIconBubble = ({
  children,
  status = "neutral",
  size = "large",
  className,
}: {
  children: ReactNode;
  status?: "positive" | "negative" | "neutral";
  size?: "small" | "large";
  className?: string;
}) => (
  <div
    className={cn(
      "h-max w-max rounded-full border border-secondary-background p-2 text-secondary-foreground dark:border-stroke-line",
      size === "small" && "p-1",
      status === "negative" &&
        "border-transparent bg-alert-yellow/30 text-status-red dark:border-alert-red/30 dark:bg-transparent",
      status === "positive" &&
        "border-none bg-status-green/20 text-status-green",
      className,
    )}
  >
    {children}
  </div>
);

export const SummaryStatusIcon = ({
  success,
  size = "large",
  className,
}: {
  success: boolean;
  size?: "small" | "large";
  className?: string;
}) => (
  <SummaryIconBubble
    className={className}
    status={success ? "positive" : "negative"}
    size={size}
  >
    {success ? (
      <CheckmarkIcon className={cn(size === "small" && "size-3")} />
    ) : (
      <AlertIcon className={cn(size === "small" && "size-3")} />
    )}
  </SummaryIconBubble>
);
